import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface WebsiteContactRequest {
  id: string;
  name: string;
  email: string;
  subject?: string | null;
  message?: string | null;
  visit_date?: string | null;
  created_at?: string;
  is_read: boolean;
  read_at?: string | null;
}

export const useWebsiteContactRequests = (enabled = true) => {
  return useQuery<WebsiteContactRequest[]>({
    queryKey: ['websiteContactRequests'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_contact_requests')
        .select('id, name, email, subject, message, visit_date, created_at, is_read, read_at')
        .order('created_at', { ascending: false })
        .limit(500);
      if (error) throw error;
      return (data as WebsiteContactRequest[]) ?? [];
    },
    enabled,
    staleTime: 60_000,
  });
};

export const useUpdateWebsiteContactRequestReadStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, isRead }: { id: string; isRead: boolean }) => {
      const updates = isRead
        ? { is_read: true, read_at: new Date().toISOString() }
        : { is_read: false, read_at: null };

      const { error } = await supabase
        .from('website_contact_requests')
        .update(updates)
        .eq('id', id);

      if (error) throw error;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['websiteContactRequests'] });
    },
  });
};
